import React, { memo } from 'react';
import { FormattedPlural } from 'react-intl';

import { Button, Flexer, Checkbox } from '@ontruck/orc';
import tel from 'utils/phone';
import { Link as LinkRouter } from 'react-router-dom';
import { Link } from '@ontruck/orc';

import { scoringParser } from 'modules/carrier';

import { ChildStyled } from './styled';

const t = {
  no_data: 'No data',
  one_job: 'job',
  other_job: 'jobs',
  offer_job: 'Offer job',
};

const JourneyOfferDriver = memo(({ showCheckbox, driver, onSelect }) => {
  const { id, contact_name, carrier_id, contact_phone, number_of_journeys } = driver;

  const scoring = scoringParser(driver);

  return (
    <Flexer.Parent mBottom="S" key={id} alignItems="center">
      {showCheckbox && (
        <Flexer.Child>
          <Checkbox name={id} onChange={onSelect} />
        </Flexer.Child>
      )}
      <ChildStyled flex="1" mRight="XS" overflow="hidden">
        <Link as={LinkRouter} to={`/carrier/${carrier_id}`} text={contact_name} />
      </ChildStyled>
      {!!scoring && (
        <Flexer.Child mRight="L" textAlign="right" width="40px">
          {scoring}
        </Flexer.Child>
      )}
      <ChildStyled mRight="L" textAlign="right" width="60px">
        {number_of_journeys} {}
        <FormattedPlural value={number_of_journeys} one={t.one_job} other={t.other_job} />
      </ChildStyled>
      <Flexer.Child>
        <Button
          ghost
          size="XS"
          skin="primary"
          icon="phone"
          iconPosition="left"
          href={tel(contact_phone)}
        />
      </Flexer.Child>
    </Flexer.Parent>
  );
});

export default JourneyOfferDriver;
